import { SUB_REFRESH_QTY } from "../actions/types";

const initialState = {
  subRefreshQuantity: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SUB_REFRESH_QTY:
      return {
        ...state,
        subRefreshQuantity: action.payload,
      };

    default:
      return state;
  }
};
